import { useState } from 'react';
import { Add, DeleteOutline } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

interface Props {
  variables: Record<string, string>;
  onChange: (variables: Record<string, string>) => void;
}

const VariablesEditor = ({ variables, onChange }: Props) => {
  const [draft, setDraft] = useState('');

  const entries = Object.entries(variables);

  const setValue = (name: string, value: string) =>
    onChange({ ...variables, [name]: value });

  const remove = (name: string) => {
    const rest = { ...variables };
    delete rest[name];
    onChange(rest);
  };

  const add = () => {
    const name = draft.trim();
    if (!name || variables[name] !== undefined) return;
    onChange({ ...variables, [name]: '' });
    setDraft('');
  };

  return (
    <Box>
      <Typography variant='body2' color='text.secondary' mb={1}>
        Se usan como <code>{'{{nombre}}'}</code> en rutas, headers y cuerpos.
        Siempre están disponibles <code>{'{{stamp}}'}</code>,{' '}
        <code>{'{{uuid}}'}</code>, <code>{'{{hoy}}'}</code> y{' '}
        <code>{'{{ahora}}'}</code>.
      </Typography>

      <Stack spacing={1}>
        {entries.map(([name, value]) => (
          <Stack key={name} direction='row' spacing={1} alignItems='center'>
            <TextField
              size='small'
              label={name}
              value={value}
              onChange={(event) => setValue(name, event.target.value)}
              fullWidth
            />
            <IconButton
              size='small'
              aria-label={`Quitar ${name}`}
              onClick={() => remove(name)}
            >
              <DeleteOutline fontSize='small' />
            </IconButton>
          </Stack>
        ))}
      </Stack>

      <Stack direction='row' spacing={1} mt={2}>
        <TextField
          size='small'
          label='Variable nueva'
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') add();
          }}
        />
        <Button startIcon={<Add />} onClick={add}>
          Agregar
        </Button>
      </Stack>
    </Box>
  );
};

export default VariablesEditor;
